import { head } from 'ramda';

import type { Context } from '@/overmind';

import type { CalculationState } from '../../index';
import { CalculationTacticProcessingTimes } from './CalculationTacticProcessingTimes';
import { getFeedingTransformerName } from './getFeedingTransformerName';
import { getSubstationName } from './getSubstationName';
import { Features } from '../../createGridElementCalculationSetExecutionDetails';

export const calculationSetStatistics = (
  state: CalculationState,
  rootState: Context['state']
): CalculationState['calculationSetStatistics'] => {
  if (state.isCalculationTacticResultUnavailable)
    return { type: 'NO_STATISTICS' };
  if (state.gridElementDetails.type === 'NO_EVALUATION')
    return { type: 'NO_STATISTICS' };
  if (state.calculationTactic.value?.status !== 'Completed') {
    return { type: 'NO_STATISTICS' };
  }

  const calculationTactic = state.calculationTactic.value;

  const powerTransformer = head(
    calculationTactic.calculationSetResult.grid.functional.powerTransformers
  );
  const feedingTransformerName = getFeedingTransformerName(
    powerTransformer,
    rootState.arcgis.featureGeometries
  );
  const features = new Features(rootState.arcgis.featureGeometries.value?.flatMap(feature => feature.features) || []);
  const substationName = getSubstationName(
    calculationTactic.calculationSetResult.grid.containment,
    features
  );
  return {
    type: 'CALCULATION_SET_STATISTICS',
    statistics: {
      totalGridElements: state.gridElementDetails.elements.length,
      acLinesCount: state.gridElementDetails.elements.filter(
        gridElement => gridElement.objectType === 'AcLineSegment'
      ).length,
      energyConsumersCount: state.gridElementDetails.elements.filter(
        gridElement => gridElement.objectType === 'EnergyConsumer'
      ).length,
      cabinetsCount:
        calculationTactic.calculationSetResult.grid.containment.filter(
          containment => containment.containerType === 'Cabinet'
        ).length,
      databaseName: '1',
      feedingTransformerName:
        feedingTransformerName.type === 'TRANSFORMER_NAME'
          ? feedingTransformerName.name
          : 'N/A',
      substationName:
        substationName.type === 'SUBSTATION_NAME' ? substationName.name : 'N/A',
      calculationsIncluded: {
        loadFlow:
          calculationTactic.calculationSetResult.calculationScenarios.loadFlow.map(
            scenario => scenario.scenarioName
          ),
        shortCircuit:
          calculationTactic.calculationSetResult.calculationScenarios.shortCircuit.map(
            scenario => scenario.scenarioName
          )
      },
      processingTimes: CalculationTacticProcessingTimes.fromExecutionTimes(
        calculationTactic.calculationSetResult.executionTimes
      ).asProcessingTimes()
    }
  };
};
